import Grid from '@mui/material/Grid';
import classNames from 'classnames';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import useIsMobile from '/@/utils/hooks/is-mobile';
import Title from '/@/v3/components/title';
import CultivioDesktop from '/@/views/catalog/assets/CultivioDesktop.png';
import CultivioMobile from '/@/views/catalog/assets/CultivioMobile.png';
import TijeretaDesktop from '/@/views/catalog/assets/TijeretaDesktop.png';
import TijeretaMobile from '/@/views/catalog/assets/TijeretaMobile.png';
import styles from '../styles.module.css';

const Vtpro4Warning = () => {
    let backgroundImage;
    const isMobile = useIsMobile();
    const isCultivio = settings.app.theme === 'cultivio';
    backgroundImage = isMobile
        ? isCultivio
            ? CultivioMobile
            : TijeretaMobile
        : isCultivio
          ? CultivioDesktop
          : TijeretaDesktop;
    return (
        <Grid
            container
            direction='column'
            spacing={isMobile ? 0 : 2}
            sx={{
                my: 2,
                ml: 0,
                px: 1,
                pt: 1,
                pb: isMobile ? '160%' : '36%',
                border: 1,
                borderRadius: 3,
                borderColor: '#cccccc',
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'bottom',
            }}
        >
            <Grid item sx={{ mb: isMobile ? 2 : 0 }}>
                <Grid container direction='row' justifyContent='flex-start' alignItems='center'>
                    <Grid item sx={{ mr: 1 }}>
                        <i className={classNames('material-icons', styles.iconInfo)}>info</i>
                    </Grid>
                    <Grid item>
                        <Title color='white' className={styles.titleIconWarning}>
                            {_('Información Importante')}
                        </Title>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item sx={{ mb: isMobile ? 2 : 0 }}>
                <Title className={styles.titleWarning}>
                    {_(
                        'Aplicaciones de productos a base de glifosato en post emergencia en maíces con tecnología VTPRO4'
                    )}
                </Title>
            </Grid>
            <Grid item sx={{ mb: isMobile ? 2 : 0 }}>
                <Title className={styles.subtitleWarning}>{_('Nueva ventana segura de aplicación')}</Title>
            </Grid>
            <Grid item sx={{ mb: isMobile ? 2 : 0 }}>
                <Title className={styles.textWarning}>
                    {_(
                        'Para maíces conteniendo la tecnología VTPRO4 se debe aplicar productos a base de glifosato hasta el estadio V5 inclusive del cultivo. Si se aplica por fuera de dicha ventana (a partir de V6) podrían ocurrir daños en el cultivo de maíz.'
                    )}
                </Title>
            </Grid>
            <Grid item>
                <Title className={styles.textWarning}>
                    {_(
                        'Maíces con la tecnología VTPRO4 bajo ciertas condiciones (interacción germoplasma/ambiente/manejo del cultivo) podría ser más sensible a aplicaciones tardías de glifosato realizadas a partir de V6. Ante cualquier duda, contactarse con su distribuidor/asesor Bayer de confianza y/o consulte a un experto a través de {{appUrl}}.',
                        {
                            appUrl: settings.app.url,
                        }
                    )}
                </Title>
            </Grid>
        </Grid>
    );
};

export default Vtpro4Warning;
